import { useRef, useState } from 'react';

import ResultsTable from './components/ResultsTable';
import { getWeblinkFromApi } from './utils/getWeblinkFromApi';
import CustomFileReader from './components/CustomFileReader';
import TabSelector from './components/TabSelector';

const domain = process.env.NODE_DOMAIN || '';
const RE_COPILOT_LINK = /^https:\/\/(?:[a-z]+-)?copilot(?:-app)?\.condenast\.io\/([^/]+)\/([^/]+)\/([^/]+)\/?/;

const StatusReport = () => {
  const [component, setComponent] = useState('pasteLinks');
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const textAreaRef = useRef(null);

  async function handleLinks(event) {
    setIsLoading(true);
    setResults([]);
    const values = event.type == 'click' ? textAreaRef?.current?.value : event.join("\n");
    const nonMatch = [];
    let descriptors = values.split('\n').reduce((acc, line) => {
      const url = line.trim();
      const matches = RE_COPILOT_LINK.exec(url);
      if (matches) {
        const [, brand, collection, id] = matches;
        acc.push({ brand, collection, id });
      } else {
        nonMatch.push(url);
      }

      return acc;
    }, []);

    // Try to get info from Brand API
    if (nonMatch.length > 0) {
      const webLinkDescriptor = await Promise.all(nonMatch.map(async (webUrl) => {
        const { brand, collection, id } = await getWeblinkFromApi(webUrl);
        return id
          ? { brand, collection, id }
          : { message: `Could not find info for ${webUrl}` };
      }));
      // Add array elements to other links and remove non Conde results
      descriptors = descriptors.concat(webLinkDescriptor);
    }

    const results = await Promise.all(descriptors.map(async ({ id, message }) => {
      if (id) {
        const res = await fetch(`${domain}/newsbundle/${id}`);
        return res.json();
      } else {
        return { message, statusCode: 404 }
      }
    }));

    setIsLoading(false);
    setResults(results)

    setIsLoading(false);
    setResults(results)
  }

  const handleClearResults = () => {
    if (!results.length) return;
    setResults([]);
  }

  return (
    <>
      <div className="card color-white">
        <div className='tab__options'>
          <TabSelector
            component={component}
            setComponent={setComponent}
            handleClearResults={handleClearResults}
            tabName="pasteLinks"
            label="Manually"
          />
          <TabSelector
            component={component}
            setComponent={setComponent}
            handleClearResults={handleClearResults}
            tabName="csv"
            label="By CSV File"
          />
        </div>
        <div className="card__header">
          <h2 className="card__label">Status Reports</h2>
        </div>
        <div className="card__body">
          {
            component != 'csv' ? (
              <>
                <label htmlFor="body-text">Copilot Links</label>
                <textarea ref={textAreaRef} name="Body Text" id="body-text" cols="30" rows="3"></textarea>
                <p className="form-help">Paste one URL per line</p>
              </>
            ) : (
              <CustomFileReader handleLinks={handleLinks} />
            )
          }
          <div className='switch__container'>
            {
              component != 'csv' && (
                <button className="button button--primary" disabled={isLoading} onClick={event => handleLinks(event)}>{isLoading ? 'Processing' : 'Submit'}</button>
              )
            }
          </div>
        </div>
      </div>
      <ResultsTable results={results} />
    </>
  );
}

export default StatusReport;
